import VueBaseController from '../../vue_base'

export class NewController extends VueBaseController {
  static get COMPONENT() { return () => import('@/vue/pages/clients/ai_content/contents/new.vue') }
}
